export default __webpack_public_path__ + "img/29.0c62eca1.jpg";